<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CHAPTER1" id="u9qK3lmXteXcFnJei6iagg2" lang="en-US"><a id="uTMD4RNta3vMv98dQAZUj9C"></a>Foreword by Branka DiGangi</p>
<p class="FIRSTPARAGRAPH" lang="en-US">My son dreamed of being the world’s greatest gem heist mastermind. He could never achieve that goal because his father already held that title. Not only did he mastermind the most astonishing series of diamond heists in history, but he was never caught, never prosecuted, never spent a day in prison, never hurt anyone in the process, and only robbed firms that were fully insured or over-insured. </p>
<p class="Normal" lang="en-US">Our son followed his father’s path. He created new techniques and methods later used worldwide by the notorious Pink Panthers who, despite reports to the contrary, originated not in Serbia, but in New York’s diamond district when my former husband, Mr. Stan, and our only son, Paul, were stealing Manhattan.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Foreword_2.vue?1a443598